import React from 'react';

const Logo = ({ size = 40, className = '', animated = false }) => {
  const styles = animated ? `
    @keyframes breathe {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.05); }
    }
    .holocron-shape {
      animation: breathe 3s ease-in-out infinite;
      transform-origin: 50px 50px;
    }
  ` : '';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {animated && <style>{styles}</style>}

      <g className={animated ? "holocron-shape" : ""}>
        {/* Outer pentagon */}
        <path
          d="M50 5 L93 35 L76 88 L24 88 L7 35 Z"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinejoin="round"
          fill="none"
        />

        {/* Inner pentagon */}
        <path
          d="M50 25 L75 42 L65 72 L35 72 L25 42 Z"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinejoin="round"
          fill="none"
        />

        {/* Connection lines */}
        <line x1="50" y1="5" x2="50" y2="25" stroke="currentColor" strokeWidth="3" />
        <line x1="93" y1="35" x2="75" y2="42" stroke="currentColor" strokeWidth="3" />
        <line x1="76" y1="88" x2="65" y2="72" stroke="currentColor" strokeWidth="3" />
        <line x1="24" y1="88" x2="35" y2="72" stroke="currentColor" strokeWidth="3" />
        <line x1="7" y1="35" x2="25" y2="42" stroke="currentColor" strokeWidth="3" />
      </g>
    </svg>
  );
};

export default Logo;
